import { InjectionToken } from '@angular/core';
export const FOLDERABLE_APP_CONFIG = new InjectionToken('Folderable App Config');
export const IS_MODAL_VIEW = new InjectionToken('Is Modal View');
export const MAX_VIEW_DEPTH = 4;
